<template>
  <v-container fluid pa-0>
    <v-layout>
      <v-flex grow class="page-container">
        <v-content>
          <transition name="slide-fade" mode="out-in">
            <router-view :key="$route.fullPath"></router-view>
          </transition>
        </v-content>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AppBar from "./AppBar/AppBar";
import Page from "./Page/Page";

export default {
  name: "AppPage",
  components: { Page, AppBar },
};
</script>

<style lang="scss">
.top-bar {
  position: fixed;
  width: 100%;
  height: 54px;
  background: darken($color-sidebar, 0%);
  z-index: 1000;

  .top-logo {
    padding: 6px 0 0 20px;
    font-size: 20pt;
    font-weight: 700;
    font-family: "Source Sans Pro";
    letter-spacing: -1px;
    color: #ef5350;
  }
}

@media (max-width: 1024px) {
  .top-logo {
    padding-left: 16px !important;
  }
}

.small-nav {
  float: left;
  display: flex;
  width: 220px;
  padding: 15px 0 0 20px;

  .small-page {
    display: flex;
    padding-right: 16px;
  }
  .small-icon {
    padding-top: 5px;
    padding-right: 5px;
  }
  .small-icon-i {
    color: $color-blue;
    font-size: 13pt;
  }
  .small-label {
    color: #222;
    font-weight: 600;
    font-size: 14pt !important;
    font-family: "Source Sans Pro";
  }
}

.app-bar-container {
  position: fixed;
  z-index: 999;
  width: 228px;
  height: 2000px;
  background: darken($color-sidebar, 3%);
  //border-top: 3px solid darken($color-sidebar, 4%);
  border-right: 0px solid darken(#f9f1ea, 2%);
}

.page-container {
  background: lighten(#fff, 2%) !important;
  z-index: 0 !important;
}

.clearfix {
  clear: both;
}
</style>